var ScrollIndicator = /** @class */ (function () {
    function ScrollIndicator(table, wrapper) {
        this.table = table;
        this.wrapper = wrapper;
        this.initialX = 0;
        this.xOffset = 0;
        this.maxX = 0;
        this.tempX = 0;
        this.active = false;
        this.create();
        this.updateDraggerWidth();
        this.updateWidth();
    }
    ScrollIndicator.prototype.disable = function () {
        this.element.style.display = 'none';
    };
    ScrollIndicator.prototype.enable = function () {
        this.element.style.display = 'block';
    };
    ScrollIndicator.prototype.hide = function () {
        this.element.classList.add('-hidden');
    };
    ScrollIndicator.prototype.show = function () {
        this.element.classList.remove('-hidden');
    };
    ScrollIndicator.prototype.create = function () {
        var _this = this;
        var element = document.createElement('div');
        var dragger = document.createElement('div');
        element.classList.add('acp-scrolling-indicator');
        element.classList.add('-start');
        element.classList.add('-hidden');
        dragger.classList.add('acp-scrolling-indicator__dragger');
        element.appendChild(dragger);
        document.body.appendChild(element);
        this.element = element;
        this.dragger = dragger;
        setTimeout(function () {
            _this.maxX = element.clientWidth - dragger.offsetWidth;
        });
        this.initEvents();
        this.disable();
        this.updateYPosition();
    };
    ScrollIndicator.prototype.updateWidth = function () {
        this.element.style.width = this.table.offsetWidth + 'px';
    };
    ScrollIndicator.prototype.updateYPosition = function () {
        var tableBottom = this.table.getBoundingClientRect().bottom;
        var bottom = window.innerHeight - tableBottom;
        if (bottom > this.element.offsetHeight) {
            this.element.style.top = (window.innerHeight - bottom) + 'px';
        }
        else {
            this.element.style.top = 'inherit';
        }
    };
    ScrollIndicator.prototype.updateDraggerWidth = function () {
        var percentage = Math.round((this.table.offsetWidth / this.table.scrollWidth * 100));
        if (percentage === 100) {
            this.element.classList.add('-fits');
        }
        else {
            this.element.classList.remove('-fits');
        }
        this.dragger.style.width = percentage + "%";
        this.maxX = this.element.clientWidth - this.dragger.offsetWidth;
    };
    ScrollIndicator.prototype.initEvents = function () {
        var _this = this;
        document.addEventListener('scroll', function () {
            _this.updateYPosition();
            _this.updateWidth();
        });
        window.addEventListener("touchmove", function (e) { return _this.drag(e); }, false);
        window.addEventListener("mousemove", function (e) { return _this.drag(e); }, false);
        window.addEventListener('mouseup', function (e) { return _this.dragEnd(); });
        this.dragger.addEventListener("touchstart", function (e) { return _this.dragStart(e); }, { passive: true });
        this.dragger.addEventListener("touchend", function () { return _this.dragEnd(); }, { passive: true });
        this.dragger.addEventListener("mousedown", function (e) { return _this.dragStart(e); }, { passive: true });
        this.dragger.addEventListener("mouseup", function () { return _this.dragEnd(); }, { passive: true });
        this.table.addEventListener('scroll', function () {
            _this.updateIndicator();
        });
        window.addEventListener('resize', function () {
            clearTimeout(_this.timeout);
            _this.timeout = setTimeout(function () {
                _this.updateWidth();
                _this.updateDraggerWidth();
            }, 100);
        });
        // Screen Option fix
        onElementHeightChange(document.getElementById('wpbody-content'), function () {
            _this.refreshPosition(300);
        });
    };
    ScrollIndicator.prototype.refreshPosition = function (delay) {
        var _this = this;
        if (delay === void 0) { delay = 100; }
        setTimeout(function () {
            _this.show();
            _this.updateYPosition();
        }, delay);
    };
    ScrollIndicator.prototype.updateIndicator = function () {
        if (this.active) {
            return;
        }
        var percentage = this.wrapper.getOffsetPercentage() / 100;
        var offset = Math.round(this.maxX * percentage);
        if (offset > this.maxX) {
            offset = this.maxX;
        }
        this.xOffset = offset;
        this.setTranslate(offset);
    };
    ScrollIndicator.prototype.getCurrentOffset = function () {
        return this.xOffset;
    };
    ScrollIndicator.prototype.dragStart = function (e) {
        this.initialX = DragHelper.getX(e);
        this.active = true;
    };
    ScrollIndicator.prototype.dragEnd = function () {
        if (!this.active) {
            return;
        }
        this.initialX = 0;
        this.active = false;
        this.xOffset = this.tempX;
        AdminColumns.HorizontalScrolling.wrapper.setOffset(this.percentage);
    };
    ScrollIndicator.prototype.drag = function (e) {
        if (this.active) {
            e.preventDefault();
            var movementX = DragHelper.getX(e) - this.initialX;
            var newXpos = this.getCurrentOffset() + movementX;
            if (newXpos < 0)
                newXpos = 0;
            if (newXpos > this.maxX)
                newXpos = this.maxX;
            this.tempX = newXpos;
            this.percentage = (newXpos / this.maxX) * 100;
            this.setTranslate(newXpos);
            AdminColumns.HorizontalScrolling.wrapper.setOffset(this.percentage);
        }
    };
    ScrollIndicator.prototype.setTranslate = function (xPos) {
        if (xPos === 0) {
            this.element.classList.add('-start');
        }
        else {
            this.element.classList.remove('-start');
        }
        this.dragger.style.left = xPos + "px";
    };
    return ScrollIndicator;
}());
export default ScrollIndicator;
var onElementHeightChange = function (element, callback) {
    var lastHeight = element.clientHeight, newHeight;
    (function run() {
        newHeight = element.clientHeight;
        if (lastHeight !== newHeight) {
            callback(newHeight);
        }
        lastHeight = newHeight;
        var timer = parseInt(element.dataset.onElementHeightChangeTimer);
        if (timer) {
            clearTimeout(parseInt(element.dataset.onElementHeightChangeTimer));
        }
        element.dataset.onElementHeightChangeTimer = setTimeout(run, 200);
    })();
};
var DragHelper = /** @class */ (function () {
    function DragHelper() {
    }
    DragHelper.getX = function (e) {
        if (e.type === "touchmove") {
            return e.touches[0].clientX;
        }
        else {
            return e.clientX;
        }
    };
    DragHelper.getY = function (e) {
        if (e.type === "touchmove") {
            return e.touches[0].clientY;
        }
        else {
            return e.clientY;
        }
    };
    return DragHelper;
}());
